import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

const StockDetails = () => {
    const { ticker } = useParams();
    const { state } = useLocation();
    const stock = state?.stock;

    if (!stock) {
        return <div className="text-center mt-3 text-danger">Stock not found</div>;
    }

    return (
        <div className="container mt-3 text-light">
            <h2>Stock Details: {ticker}</h2>
            <pre
                style={{
                    background: '#212529',
                    color: '#f8f9fa',
                    padding: '16px',
                    borderRadius: '4px',
                    overflowX: 'auto',
                    maxHeight: 'calc(100vh - 150px)',
                    overflowY: 'auto',
                    fontFamily: "monospace",
                    textAlign: 'left',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-all',
                }}
            >
                {JSON.stringify(stock, null, 2)}
            </pre>
        </div>
    );
};

export default StockDetails;